import type { MouseEvent } from "react";
import { NodeViewWrapper, NodeViewContent } from "@tiptap/react";
import type { NodeViewProps } from "@tiptap/react";
import { useUnifiedValues } from "@/components/unified/UnifiedValuesContext";

export function SectionHeadingNodeView({ node }: Readonly<NodeViewProps>) {
  const { collapsedSections, onCollapseSection, onToggleSection, sectionToggles } =
    useUnifiedValues();
  const { required, sectionId } = node.attrs as { sectionId: string | null; required: boolean };
  const enabled = sectionId ? (sectionToggles[sectionId] ?? true) : true;
  const collapsed = sectionId ? (collapsedSections[sectionId] ?? false) : false;

  const handleClick = (e: MouseEvent) => {
    // Don't toggle collapse when clicking the checkbox or editing text
    if ((e.target as HTMLElement).closest(".section-enabled-checkbox")) {
      return;
    }
    if (sectionId) {
      onCollapseSection(sectionId);
    }
  };

  return (
    <NodeViewWrapper as="h2" className="section-heading-node" onClick={handleClick}>
      {sectionId && !required && (
        <input
          type="checkbox"
          className="section-enabled-checkbox"
          checked={enabled}
          onChange={() => {
            onToggleSection(sectionId);
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
          contentEditable={false}
          title="Include in report"
        />
      )}
      {sectionId && (
        <span
          className="section-collapse-indicator"
          contentEditable={false}
          title={collapsed ? "Expand section" : "Collapse section"}
        >
          {collapsed ? "\u25B6" : "\u25BC"}
        </span>
      )}
      <NodeViewContent />
    </NodeViewWrapper>
  );
}
